import { PROFFEO_CHART_COLORS } from '@app/shared/ui/tokens/chart.tokens';

export enum AbsenceTypeEnum {
  HOLIDAY = 'Holiday',
  SICK_LEAVE = 'SickLeave',
  SICK_LEAVE_CHILD = 'SickLeaveChild',
  PUBLIC_HOLIDAY = 'PublicHoliday',
  OVERTIME_MINUS = 'OvertimeMinus',
  HOURS_BANK_MINUS = 'HoursBankMinus',
  OTHER = 'Other'
}

export interface AbsenceTypeConfig {
  label: string;
  color: string;
}

const ABSENCE_TYPE_COLORS = {
  HOLIDAY: PROFFEO_CHART_COLORS.holiday,
  SICK_LEAVE: PROFFEO_CHART_COLORS.sickLeave,
  SICK_LEAVE_CHILD: PROFFEO_CHART_COLORS.sickLeaveChild,
  PUBLIC_HOLIDAY: PROFFEO_CHART_COLORS.publicHoliday,
  OVERTIME_MINUS: PROFFEO_CHART_COLORS.overtimeMinus,
  HOURS_BANK_MINUS: PROFFEO_CHART_COLORS.hoursBankMinus,
  OTHER: PROFFEO_CHART_COLORS.other
};

export const ABSENCE_TYPE_LABELS = {
  HOLIDAY: 'Holiday',
  SICK_LEAVE: 'Sick Leave',
  SICK_LEAVE_CHILD: 'Sick Leave (Child)',
  PUBLIC_HOLIDAY: 'Public Holiday',
  OVERTIME_MINUS: 'Overtime Minus',
  HOURS_BANK_MINUS: 'Hours Bank Minus',
  OTHER: 'Other'
};

export const ABSENCE_TYPE_CONFIG: Record<AbsenceTypeEnum, AbsenceTypeConfig> = {
  [AbsenceTypeEnum.HOLIDAY]: {
    label: ABSENCE_TYPE_LABELS.HOLIDAY,
    color: ABSENCE_TYPE_COLORS.HOLIDAY
  },
  [AbsenceTypeEnum.SICK_LEAVE]: {
    label: ABSENCE_TYPE_LABELS.SICK_LEAVE,
    color: ABSENCE_TYPE_COLORS.SICK_LEAVE
  },
  [AbsenceTypeEnum.SICK_LEAVE_CHILD]: {
    label: ABSENCE_TYPE_LABELS.SICK_LEAVE_CHILD,
    color: ABSENCE_TYPE_COLORS.SICK_LEAVE_CHILD
  },
  [AbsenceTypeEnum.PUBLIC_HOLIDAY]: {
    label: ABSENCE_TYPE_LABELS.PUBLIC_HOLIDAY,
    color: ABSENCE_TYPE_COLORS.PUBLIC_HOLIDAY
  },
  [AbsenceTypeEnum.OVERTIME_MINUS]: {
    label: ABSENCE_TYPE_LABELS.OVERTIME_MINUS,
    color: ABSENCE_TYPE_COLORS.OVERTIME_MINUS
  },
  [AbsenceTypeEnum.HOURS_BANK_MINUS]: {
    label: ABSENCE_TYPE_LABELS.HOURS_BANK_MINUS,
    color: ABSENCE_TYPE_COLORS.HOURS_BANK_MINUS
  },
  [AbsenceTypeEnum.OTHER]: {
    label: ABSENCE_TYPE_LABELS.OTHER,
    color: ABSENCE_TYPE_COLORS.OTHER
  }
};
